import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { HrefResolverService } from '@blk/cwp-ng-framework';
import { AnalyticsHelperUtil } from '@ddt-web/analytics';
import { APPLICATION_NAME_TOKEN, ApplicationName } from '@ddt-web/config';
import { GridClass, WebUserDataConstants } from '@ddt-web/domain';
import { UrlRedirectService } from '@ddt-web/url';

@Component({
	selector: 'ac-welcome-screen',
	templateUrl: './welcome-screen.component.html',
	styleUrls: ['./welcome-screen.component.scss']
})
export class WelcomeScreenComponent {
	@Input() public isModal: boolean = false;
	@Input() public useAladdinBranding: boolean;
	@Input() public gridClass: GridClass = GridClass.GRID_980;

	@Output() public onOpenPortfolioTableClick: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() public onCreateNewClick: EventEmitter<boolean> = new EventEmitter<boolean>();

	public analyticsAppKey: string;

	public origin: string = WebUserDataConstants.APPLICATIONS.BFA_MODELS;
	public applications: string[] = [WebUserDataConstants.APPLICATIONS.BFA, WebUserDataConstants.APPLICATIONS.BFA_MODELS];

	constructor(
		private urlRedirectService: UrlRedirectService,
		public hrefResolverService: HrefResolverService,
		@Inject(APPLICATION_NAME_TOKEN) private applicationName: ApplicationName
	) {
		this.analyticsAppKey = AnalyticsHelperUtil.getAnalyticsAppKey(this.applicationName);
	}

	public directToPortfolioEditor(): void {
		this.onCreateNewClick.emit(true);
		this.urlRedirectService.redirectToPortfolioEditorView({});
	}

	public openPortfolioTable(): void {
		this.onOpenPortfolioTableClick.emit(true);
	}

}
